import { computed } from 'mobx'
import { schema } from 'prose-core'
import { useContext } from 'react'

import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { EditorView } from 'prosemirror-view'
import { timedOutToggleMark } from '../utils/util'

export function useUnderlineToggle(view: EditorView): ButtonHook {
  const almanacState = useContext(AlmanacEditorStateContext)
  const hasUnderline = computed(() => almanacState?.activeMarks.has(schema.marks.underline)).get()
  const hasCodeBlock = computed(() => almanacState?.activeNodes.has(schema.nodes.code_block)).get()

  return {
    active: !!hasUnderline,
    handleClick: timedOutToggleMark(schema.marks.underline, view),
    disabled: hasCodeBlock,
  }
}
